module.exports = __webpack_public_path__ + "static/img/9.f736f80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/9.png
// module id = OFLQ
// module chunks = 0